let $middleBlue = '#81acd9'
let $selectTriggerBtn = {
  'border' : '1px solid #bcd5ef',
  'color' : $middleBlue,
  'padding' : '0 10px'
}

  export default {
'button' : { 

 typeTheme :{ 
 'swtichAccount' : { 
  'line-height' : '30px'
 
}} 
}
,
'selectTriggerBtn' : { 
  commonTheme : {
  'height' : '40px',
  'line-height' : '40px',
  'background-color' : 'white'
  },
 typeTheme :{ 
 'bankSelect' : { 
  ...$selectTriggerBtn,
  'width' : '85%',
  'height' : '60px',
  'margin' : '0 auto',
  'text-align' : 'center'
 
}} 
}

}